export const APPLE_PAYLATER_QUERY_PARAMS = {
  USER_HAS_INSTORE_CARD: 'userHasInStoreCard',
  USER_HAS_APPLE_PAYLATER_CARD: 'userHasApplePaylaterCard',
} as const
